import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, LinkButton } from 'fronton-react';
import { analyticsUtils } from 'utils';
import { useBreakpoints } from 'common/hooks';
import { button, root, container, containerText, title, text, nut, left, right } from './styles';

type Props = {
  productName: string;
  productId?: string;
  productTag: string;
  productPrice?: number | null;
  productPrevPrice?: number | null;
  productDiscount?: number | null;
};

export const DATA_QA_PUSH_PROMO_BANNER = 'push-promo-banner';

export function PushPromoBanner({
  productName,
  productId,
  productPrice,
  productPrevPrice,
  productTag,
  productDiscount,
}: Props) {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints() || {
    tablet: false,
  };

  const analytics = {
    elementType: 'banner',
    elementBlock: 'productDetail',
    promotions: [
      {
        name: 'productDetailLoyalty',
        creative: 'Промокод на скидку в личном кабинете',
        position: '1',
      },
    ],
    productName,
    productId,
    productPrice,
    productPrevPrice,
    productTag,
    productDiscount,
    productBelong: 'LeroyMerlin',
  };

  function sendAnalytics() {
    analyticsUtils.sendEvent('GA:promoClick', analytics);
  }

  useEffect(() => {
    analyticsUtils.sendEvent('GA:promoView', analytics);
  }, []);

  return (
    <LinkButton
      onClick={sendAnalytics}
      className={button}
      href="/lk/promocodes/"
      data-qa={DATA_QA_PUSH_PROMO_BANNER}
    >
      <div className={root}>
        <div className={left}>
          <div className={title}>
            <Typography size="subtitle" variant="m" color="text-primary">
              {t('push-promo-banner.title1')}
            </Typography>
            {tablet ? ' ' : <br />}
            <Typography size="subtitle" variant="m" color="text-primary">
              {t('push-promo-banner.title2')}
            </Typography>
          </div>
          <Typography className={text} size="body_short" variant="l" color="text-primary">
            {t('push-promo-banner.text1')}
          </Typography>
        </div>
        <div className={right}>
          <div className={container}>
            <div className={nut} />
            <Typography className={containerText} size="caption_accent" variant="minor">
              {t('push-promo-banner.text2')}
            </Typography>
          </div>
        </div>
      </div>
    </LinkButton>
  );
}
